module.exports = __webpack_public_path__ + "img/76341cc22f1a611ab6b6c02f6a0c75ae.png";